module.exports = __webpack_public_path__ + "img/timer.9f082b75.gif";